import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'; // Install moment.js using npm if not already installed

@Pipe({
  name: 'dateTimeFormatter',
  standalone: true
})
export class DateTimeFormatterPipe implements PipeTransform {

  transform(dateString: string): string {
    if (!dateString) return '';

    // const date = moment.default(dateString);
    // const today = moment.default().startOf('day'); // Start of today's date for comparison

    const date = moment.utc(dateString).local(); // Convert to local time
    const today = moment.default().startOf('day'); // Start of today's date in local time
    if (date.isSame(today, 'day')) {
      // If the date is today, return the time
      return date.local().format('h:mm A'); // e.g., "10:30 AM"
    } else {
      // If the date is not today, return the formatted date
      return date.local().format('DD MMM YYYY'); // e.g., "15 Oct 2024"
    }
  }
}
